import type { ComponentProps, ReactNode } from 'react'
import type { To } from 'react-router-dom'
import { OrgNavLink, type OrgNavLinkProps } from '@/components/shared/OrgLink'

type ButtonProps = ComponentProps<'button'>

type AppSidebarItemProps = {
  to?: To
  children: ReactNode
  onClick?: () => void
} & Omit<OrgNavLinkProps, 'to' | 'children' | 'onClick'> &
  Omit<ButtonProps, 'children' | 'onClick'>

export function AppSidebarNavItem({ to, children, onClick, ...rest }: AppSidebarItemProps) {
  if (to !== undefined && to !== null) {
    return (
      <OrgNavLink to={to} {...rest}>
        {children}
      </OrgNavLink>
    )
  }

  return (
    <button type="button" onClick={onClick} className="w-full text-left" {...rest}>
      {children}
    </button>
  )
}
